import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // if (error.response && error.response.status === 401) {
        //    console.log('oi')
        //     window.location.href = '/';
        // }

        return Promise.reject(error);
    },
);

export default api;
